import { z } from "zod";

import { idNameSchema } from "./generic-schema.ts";

// subSchemas //
export const detailfreightClassSchema = idNameSchema.extend({
	numericValue: z.number(),
	stringValue: z.string(),
	description: z.string(),
	weightRangePerCubicFoot: z.string(),
	code: z.string(),
});

// GET request Schemas//
// Endpoint: /api/create-quote/commodity-templates?customerId=584182
export const commoditySchema = z.object({
	id: z.number(),
	customerId: z.number(),
	customer: idNameSchema,
	description: z.string().nullable(),
	unitTypeId: z.number().nullable(),
	unitType: idNameSchema,
	quantity: z.number().nullable(),
	weight: z.number().nullable(),
	dimensionLength: z.number().nullable(),
	dimensionWidth: z.number().nullable(),
	dimensionHeight: z.number().nullable(),
	freightClassId: z.number().nullable(),
	freightClass: detailfreightClassSchema.nullable(),
	nmfc: z.string().nullable(),
	isStackable: z.boolean().nullable(),
	isHazmat: z.boolean().nullable(),
});

//POST request Schemas //
// Endpoint: /api/create-quote/commodity-templates
export const commodityNewSchema = z.object({
	customerId: z.number(),
	description: z.string().nullable(),
	unitTypeId: z.number(),
	quantity: z.number().nullable(),
	weight: z.number().nullable(),
	dimensionLength: z.number().nullable(),
	dimensionWidth: z.number().nullable(),
	dimensionHeight: z.number().nullable(),
	freightClassId: z.number().nullable(),
	nmfc: z.string().nullable(),
	isStackable: z.boolean().nullable(),
	isHazmat: z.boolean().nullable(),
	updatedByUserId: z.number(),
	isInternal: z.boolean().optional(),
});

// Endpoint: api/create-quote/calculate-item-totals
// Response Schema
export const itemTotalsSchema = z.object({
	totalLinearFeet: z.number(),
	totalCubicFootage: z.number(),
	totalDensity: z.number(),
});

// Endpoint: api/create-quote/calculate-item-totals
// Request Schema
export const itemTotalsBodySchema = z.object({
	Commodity: z.number().nullable(), // TODO: Double check this data type
	Height: z.number(),
	Length: z.number(),
	Width: z.number(),
	Quantity: z.number(),
	Weight: z.number(),
	Stackable: z.number(),
	PieceCaseCount: z.number(),
});

// PUT request Schemas //
// Endpoint: /api/create-quote/commodity-templates/168589/update
export const commodityUpdateSchema = commoditySchema
	.omit({
		customerId: true,
		customer: true,
		unitType: true,
		freightClass: true,
		nmfc: true,
	})
	.extend({
		nationalMotorFreightClassification: z.string().nullable(),
	});

// Types
export type IdName = z.infer<typeof idNameSchema>;
export type DetailFreightClass = z.infer<typeof detailfreightClassSchema>;
export type Commodity = z.infer<typeof commoditySchema>;
export type CommodityNewBody = z.infer<typeof commodityNewSchema>;
export type CommodityUpdateBody = z.infer<typeof commodityUpdateSchema>;
export type ItemTotals = z.infer<typeof itemTotalsSchema>;
export type ItemTotalsBody = z.infer<typeof itemTotalsBodySchema>;
